import React, { useContext } from 'react'
import SubHeader from '../../components/WithSubHeaderBG'
import { Box, Text } from '../../designSystem'
import { AccountContext } from '../../providers/accountProvider'
import { NotificationsContext } from '../../providers/notificationsProvider'
import { ProgramNotificationCard } from '../Home/Cards'
import { navigateFromNotificationHandler } from '../Home/Cards/booksNotification'
import { ChapterNotificationCard } from '../Home/Cards/programNotificationCard'

const NotificationsUI = () => {
  const { notificationArr, chapterNotificationArr } = useContext(NotificationsContext)
  const { isUgcUser, isHindiUgcUser} = useContext(AccountContext)
  return (
    <Box>
      {chapterNotificationArr.length > 0 && chapterNotificationArr.map((notification) => (
        <ChapterNotificationCard notification={notification}/>
      ))}
      {!isUgcUser && !isHindiUgcUser && notificationArr.length > 0 &&
        notificationArr.map((notification) => {
          const isPending = notification.action === 'pending'
          const isUpdated = notification.action === 'updated'
          const isRejected = notification.action === 'rejected'
          let parameters = {}
          if(notification.isWriterNotification){
              parameters = {
                  ...notification,
                  closeBtnHandler: null,
                  actionBtnHandler: navigateFromNotificationHandler,
              }
          } else if(notification.action_on === 'program'){
              parameters = {
                program : notification,
                action_type: isUpdated ? 'updated' : isRejected ? 'rejected' : 'applied',
                toReplace: "{{novel_title}}",
                withReplace: notification.book_details.book_title,
                button_text: "Read Feedback",
              }
          } else if(notification.action_on === 'wallet'){
              parameters = {
                action_type: isPending ? 'applied' : isRejected ? 'rejected' : 'approved',   
                  toReplace: "{{amount}}",
                  withReplace: notification.txn_data.amount,
                  button_text: "Okay",
                  isWalletNotification: true,
              }
          } 
          return (
            <React.Fragment key={notification.id}>
                <ProgramNotificationCard hidden={!notification.type && notification.isWriterNotification} {...parameters} />
            </React.Fragment>
          )
        })}
        
    </Box>
  )
}

export default NotificationsUI
